import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import { forwardRef } from "react";
import * as t from "@rekajs/types";
import type { ComponentType } from "@repo/editor/types";

export const ContainerDefinition: ComponentSettingsProps = {
  backgroundImage: {
    type: "image",
    label: "تصویر پس زمینه",
  },
  alt: {
    type: "string",
    label: "عنوان تصویر",
    default: "تصویر پس زمینه",
  },
};

export interface ContainerProps {
  children: React.ReactNode;
  backgroundImage?: string;
  alt?: string;
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  (props, ref) => {
    return (
      <div className="relative" ref={ref}>
        {props.backgroundImage ? (
          <img
            alt={props.alt || String(ContainerDefinition.alt.default)}
            className="absolute top-0 left-0 bottom-0 right-0 -z-10 w-full h-full object-cover"
            src={props.backgroundImage}
          />
        ) : null}
        <div className="container mx-auto relative">{props.children}</div>
      </div>
    );
  }
) as ComponentType<ContainerProps>;
Container.displayName = "Container";

export const ContainerSettings: ComponentSettings = {
  name: "EContainer",
  props: ContainerDefinition,
  childrenAllowed: true,
  label: "کانتینر",
  widgets: {
    label: "کانتینر",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "EContainer", external: true }),
        children: [
          t.componentTemplate({
            component: t.identifier({
              name: "ETextImageSection",
              external: true,
            }),
          }),
        ],
      }),
  },
};

Container.componentSettings = ContainerSettings;
